module.exports = __webpack_public_path__ + "img/p_sz_20.c1dd543f.png";